import { render, staticRenderFns } from "./AtmoInfoCh2o.vue?vue&type=template&id=4eb5a920&scoped=true&"
var script = {}
import style0 from "./AtmoInfoCh2o.vue?vue&type=style&index=0&id=4eb5a920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5a920",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb5a920')) {
      api.createRecord('4eb5a920', component.options)
    } else {
      api.reload('4eb5a920', component.options)
    }
    module.hot.accept("./AtmoInfoCh2o.vue?vue&type=template&id=4eb5a920&scoped=true&", function () {
      api.rerender('4eb5a920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/integrations/templates/AtmoInfoCh2o.vue"
export default component.exports